var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableMiners(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "helmet",
    className: "me-3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 74.14 74.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11032",
    "data-name": "Group 11032",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40277",
    "data-name": "Path 40277",
    d: "M68.793,34.174A31.87,31.87,0,0,0,45.758,6.416V0H28.382V6.416A31.871,31.871,0,0,0,5.347,34.174H0V51.55H11.005v2.317A20.3,20.3,0,0,0,31.278,74.14H42.862A20.3,20.3,0,0,0,63.135,53.867V51.55H74.14V34.174ZM57.342,53.867a14.5,14.5,0,0,1-14.48,14.48H31.278A14.5,14.5,0,0,1,16.8,53.867V51.55H57.342ZM28.382,37.07a8.688,8.688,0,1,1,8.688,8.688A8.7,8.7,0,0,1,28.382,37.07Zm39.966,8.688h-19.7a14.48,14.48,0,1,0-23.154,0H5.792V39.966H16.8V34.174h-5.63A26.178,26.178,0,0,1,28.382,12.489V16.8h5.792V5.792h5.792V16.8h5.792V12.489A26.178,26.178,0,0,1,62.972,34.174h-5.63v5.792H68.347ZM39.966,37.07a2.9,2.9,0,1,0-2.9,2.9A2.9,2.9,0,0,0,39.966,37.07Z",
    transform: "translate(0)",
    fill: "#ffea00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableMiners);
export default __webpack_public_path__ + "static/media/table_miners.a411c50543db177b5b34aaacee1886a4.svg";
export { ForwardRef as ReactComponent };